export const TOGGLE_ROWS = [
  {
    key: 'paymentAfterClosing',
    title: 'Payment after closing date',
    description:
      'Host distributes delivery cost and consolidates discount at event close.',
  },
  {
    key: 'payTogether',
    title: 'Pay together',
    description: 'Members can pay for multiple events at once via Pay Together.',
  },
  {
    key: 'adminFeePerOrder',
    title: 'Admin fee per order',
    description: "Charge a fixed fee on each member's order.",
  },
  {
    key: 'orderDiscounts',
    title: 'Order discounts',
    description: 'Auto-applied per order based on individual spend or quantity.',
  },
];
